import {resources} from "../../../../../../../core/models/resource/resources";
import {EntityFileType} from "../../../../../../../core/types/file.types";

export const turnkeyCostMarketplaceResourceType = resources['turnkey-cost-to-marketplace'];
export const turnkeyCostWarehouseResourceType = resources['turnkey-cost-to-warehouse'];
export const turnkeyCostMarketplaceFilesResourceType = resources['turnkey-cost-to-marketplace-files'];
export const turnkeyCostWarehouseFilesResourceType = resources['turnkey-cost-to-warehouse-files'];
export const turnkeyCostMarketplaceFileType: EntityFileType = 'TURNKEY_COST_TO_MARKETPLACE';
export const turnkeyCostWarehouseFileType: EntityFileType = 'TURNKEY_COST_TO_WAREHOUSE';

export const modalPath: Record<string, string> = {
  turnkeyCostToMarketplaces: turnkeyCostMarketplaceResourceType.path,
  turnkeyCostToWarehouses: turnkeyCostWarehouseResourceType.path
};

export const titleModal: Record<string, string> = {
  turnkeyCostToMarketplaces: turnkeyCostMarketplaceResourceType.name,
  turnkeyCostToWarehouses: turnkeyCostWarehouseResourceType.name
};

export const filePath: Record<string, string> = {
  turnkeyCostToMarketplaces: turnkeyCostMarketplaceFilesResourceType.path,
  turnkeyCostToWarehouses: turnkeyCostWarehouseFilesResourceType.path
}

export const fileTypeState: Record<string, EntityFileType> = {
  turnkeyCostToMarketplaces: turnkeyCostMarketplaceFileType,
  turnkeyCostToWarehouses: turnkeyCostWarehouseFileType
}

export const fileKeyState: Record<string, string> = {
  turnkeyCostToMarketplaces: 'turnkeyCostToMarketplaceId',
  turnkeyCostToWarehouses: 'turnkeyCostToWarehouseId'
}
